import * as XLSX from "xlsx";
import "./user.css";
import { CiExport } from "react-icons/ci";

const TableExportButton = ({ tableData, filename }) => {
  const handleExport = () => {
    // Replace 'name' field with alias (if available)
    const formattedData = tableData.map((row) => ({
      ...row,
      name: row.role === "admin" ? row.alias || row.id : row.alias || row.name,
    }));

    // Convert table data to worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, filename || "table.xlsx");
  };

  return (
    <button onClick={handleExport} className="addUser-btnn">
      <CiExport
        style={{
          width: "1.2rem",
          height: "1.2rem",
        }}
      />
      Export
    </button>
  );
};

export default TableExportButton;
